import AppStore from '@v4/store/appStore'
import QuizQuestionsSelector from '@v4/utils/selectors/QuizQuestionsSelector'
import QuestionsBuilderSelector from '@v4/utils/selectors/QuestionsBuilderSelector'

const useQuestionSettingsField = (name, fallback) => {
	const isBuilderMode = AppStore.useStoreState(state => state.general.isBuilderMode)

	const appValue = AppStore.useStoreState(state => state.question.data?.settings?.[name] ?? fallback)
	const activeQuestionId = QuestionsBuilderSelector.useActiveQuestionId()
	const builderValue = QuizQuestionsSelector.useQuestionSettingsValue({ id: activeQuestionId, name })

	return isBuilderMode ? builderValue : appValue
}

export default useQuestionSettingsField
